import { render, staticRenderFns } from "./TPItem.vue?vue&type=template&id=2e54f772&scoped=true"
import script from "./TPItem.vue?vue&type=script&lang=js"
export * from "./TPItem.vue?vue&type=script&lang=js"
import style0 from "./TPItem.vue?vue&type=style&index=0&id=2e54f772&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e54f772",
  null
  
)

export default component.exports